import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ValueResponseDto } from '../dto/response/value-response.dto';
import { ValueSaveRequestDto } from '../dto/request/value-save-request.dto';
import { ValueUpdateRequestDto } from '../dto/request/value-update-request.dto';
import targetService from '../services/target.service';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';

const initialState = {
  status: 'idle',
  targets: [] as ValueResponseDto[] | null,
  target: {} as ValueResponseDto | null,
  error: null as string | null,
};

// export const fetchTargetById = createAsyncThunk(
//   'targets/fetchTargetById',
//   async (id: string) => {
//     return await targetService.fetchTargetById(id);
//   }
// );

export const saveTarget = createAsyncThunk(
  'targets/saveTarget',
  async (saveRequest: ValueSaveRequestDto, { rejectWithValue }) => {
    try {
      return await targetService.saveTarget(saveRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

export const updateTarget = createAsyncThunk(
  'targets/updateTarget',
  async (updateRequest: ValueUpdateRequestDto, { rejectWithValue }) => {
    try {
      return await targetService.updateTarget(updateRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

// export const updateVerificationLabel = createAsyncThunk(
//   'targets/updateVerificationLabel',
//   async (updateRequest: ValueUpdateRequestDto, { rejectWithValue }) => {
//     try {
//       return await targetService.updateVerificationLabel(updateRequest);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

// export const deleteTarget = createAsyncThunk(
//   'targets/deleteTarget',
//   async (existingId: string, { rejectWithValue }) => {
//     try {
//       return await targetService.deleteTarget(existingId);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const targetSlice = createSlice({
  name: 'targetSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchTargetById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchTargetById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.target = action.payload;
      // })
      // .addCase(fetchTargetById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveTarget.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveTarget.fulfilled, (state, action) => {
        state.status = 'succeeded';
        showSuccess('Target added successfully.');
        state.targets?.push(action.payload);
      })
      .addCase(saveTarget.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Adding target failed. ${action.payload as string}`);
      })
      .addCase(updateTarget.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateTarget.fulfilled, (state, action) => {
        state.status = 'succeeded';
        showSuccess('Target saved successfully.');
        if (state.targets) {
          const targetIndex = state.targets.findIndex(
            (target) => target.id === action.payload.id
          );
          if (targetIndex !== -1) {
            state.targets[targetIndex] = action.payload;
          }
        }
      })
      .addCase(updateTarget.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Saving target failed. ${action.payload as string}`);
      });
    // .addCase(updateVerificationLabel.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(updateVerificationLabel.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   showSuccess('Verification label saved successfully.');
    //   if (state.targets) {
    //     const targetIndex = state.targets.findIndex(
    //       (target) => target.id === action.payload.id
    //     );
    //     if (targetIndex !== -1) {
    //       state.targets[targetIndex] = action.payload;
    //     }
    //   }
    // })
    // .addCase(updateVerificationLabel.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(
    //     `Saving verification label failed. ${action.payload as string}`
    //   );
    // })
    // .addCase(deleteTarget.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteTarget.fulfilled, (state) => {
    //   state.status = 'succeeded';
    //   showSuccess('Target deleted successfully.');
    // })
    // .addCase(deleteTarget.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(`Deleteting target failed. ${action.payload as string}`);
    // });
  },
});

export default targetSlice.reducer;
